import React from "react";
import { Allocation } from "../../../types";
import { AllocationActions } from "../util";
import ActionProps from "./AllocationActionProps";
import ConfirmationButton from "./ConfirmationButton";

const ResolveIssueButton: React.FC<ActionProps<Allocation>> = (props) => {
  const { data: allocation } = props;

  const dialogContent = `Resolve the issue of this Allocation. The Delivery Order will also be created. Confirm?`;

  return (
    <ConfirmationButton
      data={allocation}
      action={AllocationActions.RESOLVE_ISSUE}
      buttonText={`Resolve Issue`}
      dialogTitle={`Resolve the Issue`}
      dialogContent={dialogContent}
      confirmationButtonText={`Confirm`}
    />
  );
};

export default ResolveIssueButton;
